__turbopack_context__.v({
  "brush-stroke": "style-module-scss-module__fzXxxW__brush-stroke",
  "brush-stroke-1": "style-module-scss-module__fzXxxW__brush-stroke-1",
  "brush-stroke-2": "style-module-scss-module__fzXxxW__brush-stroke-2",
  "container": "style-module-scss-module__fzXxxW__container",
  "content": "style-module-scss-module__fzXxxW__content",
  "hero": "style-module-scss-module__fzXxxW__hero",
  "hero-image": "style-module-scss-module__fzXxxW__hero-image",
});
